import { useContext } from 'react';

import LightboxContext from './lightbox.context';

function useLightbox() {
  const context = useContext(LightboxContext);

  if (!context) {
    throw new Error('useLightbox must be used within LightboxContext');
  }

  return context;
}

export default useLightbox;